// extracted by mini-css-extract-plugin
export default {"docCard":"style_docCard__uv8ag","content":"style_content__gyq7L","withDocument":"style_withDocument__lqiQg","noDocument":"style_noDocument__wYhGH"};